
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.113 11.5h.003a.167.167 0 00.069-.015.147.147 0 00.05-.037.123.123 0 00.027-.047.11.11 0 00.002-.05s0 0 0 0l-.633-3.57-.047-.266.196-.185L12.46 4.8 10.114 11.5zm0 0a.168.168 0 01-.073-.018m.073.018l-.073-.018m0 0s0 0 0 0L6.726 9.796 6.5 9.681l-.227.115-3.313 1.686s0 0 0 0a.168.168 0 01-.17-.011l-.288.409.288-.41a.133.133 0 01-.047-.056.11.11 0 01-.007-.062l7.304.13zm-7.304-.13l.633-3.571.047-.266-.196-.185L.54 4.802s0 0 0 0 0 0 0 0a.125.125 0 01-.037-.06l-.483.123.483-.123a.11.11 0 01.003-.063.129.129 0 01.041-.058l-.3-.369.3.369a.16.16 0 01.08-.034s0 0 0 0 0 0 0 0l3.703-.521.258-.036.118-.232L6.351.572a.17.17 0 01.055-.048L6.164.086l.242.438a.195.195 0 01.188 0 .17.17 0 01.055.048l1.645 3.226.118.232.258.036 3.704.52s0 0 0 0a.16.16 0 01.079.035.13.13 0 01.041.058.11.11 0 01.003.063.126.126 0 01-.036.06l-9.725 6.55z","stroke":"#000"}})])
          )
        }
      }
    